import React, { FC, ReactNode } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { reportTrackingEvent } from '../../tracking/thunks'
import { useReportViewEvent } from '../../hooks'
import { ErrorStepIcon } from '../../components/icons/StepIcons/ErrorStepIcon'
import { Button } from '../../components/styled/CosmaButton/CosmaButton'
import { ReduxState } from '../../store/reducers'
import './PdfErrorStep.scss'

export const PdfErrorStep: FC<ReactNode> = () => {
  useReportViewEvent({ pageTitle: 'pdferror' })
  const theme = useSelector((state: ReduxState) => state.config.theme)

  const dispatch = useDispatch()

  const reloadPage = () => {
    dispatch(
      reportTrackingEvent({
        label: 'reload-pdf_button_click',
        pageTitle: 'pdferror',
        eventName: 'lead_error',
        inputValue: 'pdf_error',
      })
    )
    window.location.reload()
  }

  return (
    <div data-theme='cosma' className='grid grid-flex grid-justify-center font-antialiased'>
      <h2
        data-testid='pdf-error-step-headline'
        className='grid-item one-whole align-center font-normal font-line-xs palm-font-xl margin-top-m margin-bottom-xxl padding-horizontal-l'
      >
        Das Bewertungs-PDF konnte nicht erstellt werden
      </h2>

      <div className='grid-item one-whole margin-top-l margin-bottom-xxl'>
        <ErrorStepIcon />
      </div>

      <div
        data-testid='pdf-error-step-message'
        className='grid-item one-whole input-text-container pdf-error-message-container padding-horizontal-l align-center'
      >
        <div>Wir bitten die Unannehmlichkeiten zu entschuldigen</div>
      </div>

      <div className='grid-item one-whole margin-top-xxl padding-horizontal-l align-center'>
        <Button
          data-testid='error-step-reload-page-button'
          onClick={reloadPage}
          appearance='primary'
          className='palm-one-whole'
          textColor={theme?.text}
          primary={theme?.primary}
          secondary={theme?.secondary}
          secondaryLight={theme?.secondaryLight}
        >
          Immobilienbewertung schließen
        </Button>
      </div>
    </div>
  )
}

export default PdfErrorStep
